export default __webpack_public_path__ + "bml-characteristic1.236c843.png";